<template>
  <div
    :class="div_classes"
    :style="{
      transform: `translate(${local_text.left}px, ${local_text.top}px)`,
      color: local_text.color,
      fontSize: local_text.size + 'px',
      textAlign: local_text.align,
      cursor: isDragging ? 'grabbing' : 'grab'
    }"
    @mousedown="start_drag"
  >
    {{ local_text.text }}
  </div>
</template>

<script>
export default {
  props: ['text', 'textIndex'],
  data() {
    return {
      isDragging: false,
      dragOffsetX: 0,
      dragOffsetY: 0,
      local_text: { ...this.text }
    };
  },
  computed: {
    div_classes() {
      return ['absolute','draggable-text', this.text.font === 'cormorant.ttf' ? 'cormorant-font' : 'tangerine-font'];
    }
  },
  watch: {
    text: {
      handler(val) {
        this.local_text = { ...val };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    start_drag(event) {
      if (event.button !== 0) return;
      this.isDragging = true;
      const rect = this.$el.getBoundingClientRect();
      this.dragOffsetX = event.clientX - rect.left;
      this.dragOffsetY = event.clientY - rect.top;
      document.addEventListener('mousemove', this.drag_move);
      document.addEventListener('mouseup', this.end_drag);
    },
    drag_move(event) {
      if (!this.isDragging) return;
      const rect = this.$el.parentElement.getBoundingClientRect();
      this.local_text.left = event.clientX - rect.left - this.dragOffsetX;
      this.local_text.top = event.clientY - rect.top - this.dragOffsetY;
      this.$emit('update-position', this.textIndex, this.local_text.left, this.local_text.top);
    },
    end_drag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.drag_move);
      document.removeEventListener('mouseup', this.end_drag);
    }
  }
};
</script>
<style scoped>
@font-face {
  font-family: 'tangerine';
  src: url('~@/assets/fonts/tangerine.ttf') format('truetype');
}

.tangerine-font {
  font-family: 'tangerine';
}

@font-face {
  font-family: 'cormorant';
  src: url('~@/assets/fonts/cormorant.ttf') format('truetype');
}

.cormorant-font {
  font-family: 'cormorant';
}

.draggable-text {
  outline: 1px dashed rgba(0, 0, 0, 0.5);
  outline-offset: 2px;
  padding: 2px;
  display: inline-block;
}
</style>
